import {ComboboxValue} from '@/components/form/combobox/combobox-content';
import {searchInvestors} from '@/repositories/beneva-api/endpoints/client-info';
import {AdvisorCodes} from './advisor-code-step';

type InvestorComboboxValue = ComboboxValue;

const searchInvestorsAsComboboxValues =
  (advisorCodes: AdvisorCodes) =>
  async (query: string): Promise<InvestorComboboxValue[]> => {
    const response = await searchInvestors(query, advisorCodes.dealerCode, advisorCodes.repCode);

    return response.data.map(investor => ({
      id: investor.investorNo.toFixed(0),
      value: investor.investorNo.toFixed(0),
      label: `${investor.investorNo} - ${investor.legalName}`,
    }));
  };

export {type InvestorComboboxValue, searchInvestorsAsComboboxValues};
